<div class="mbp-radio-group">
  <ng-content></ng-content>
</div>
